import { isValidNumber, safeStringCompare } from "../../common";

type Row = Record<string, unknown>;

export const createStringSorter = (field: string) => {
  return (a: Row, b: Row) => safeStringCompare(a[field], b[field]);
};

export const createNumberSorter = (field: string) => {
  return (a: Row, b: Row) => {
    const valA = a[field];
    const valB = b[field];

    const hasA = isValidNumber(valA);
    const hasB = isValidNumber(valB);

    if (!hasA && !hasB) {
      return 0;
    }
    if (!hasA) {
      return 1;
    }
    if (!hasB) {
      return -1;
    }

    return (valA as number) - (valB as number);
  };
};

export const createArrayStringSorter = (field: string) => {
  return (a: Row, b: Row) => {
    const arrA = Array.isArray(a[field])
      ? (a[field] as unknown[]).join(",")
      : "";
    const arrB = Array.isArray(b[field])
      ? (b[field] as unknown[]).join(",")
      : "";
    return safeStringCompare(arrA, arrB);
  };
};

export const createStatusSorter = (
  field: string,
  statusOrder: string[] = [],
) => {
  return (a: Row, b: Row) => {
    const valA = String(a[field] ?? "");
    const valB = String(b[field] ?? "");

    if (statusOrder.length > 0) {
      const indexA = statusOrder.indexOf(valA);
      const indexB = statusOrder.indexOf(valB);

      const posA = indexA === -1 ? Infinity : indexA;
      const posB = indexB === -1 ? Infinity : indexB;

      return posA - posB;
    }

    return safeStringCompare(valA, valB);
  };
};
